import Repository from './Repository';

const resource = "/groups_types";
export default {
    get(website_id) {
        return Repository.get(`${resource}`);
    },
}